import {global} from "../../../appContext";
import {IExportFlow, IExportTemplate, IMessageData, IRouteDefinitionParams} from "../../../index";
import * as ko from "knockout";
import {createErrorMessage} from "../../../util/misc";
import {nsRoute} from "../../../util/route";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import readHtml from './read.html?raw';

export let template: string = readHtml;

export class viewModel extends ParsedRouteDataDecorator {
    private dataExportTemplate!: IExportTemplate;

    isReady: KnockoutObservable<boolean> = ko.observable(false);
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);

    data!: { [key: string]: IExportFlow | undefined };

    isUsername: boolean = false;
    isEmail: boolean = false;
    isInitials: boolean = false;

    isDefined: boolean = false;

    constructor(params: IRouteDefinitionParams) {
        super(params)
        this.messageData({message: REQUEST_MESSAGE});
        global
            .getPromiseRequest("getexporttemplate")
            .request({id: global.getRouteId()})
            .then((data: IExportTemplate[]) => {
                const template = data[0];
                if (!template) {
                    throw new Error('Missing export template');
                }
                this.dataExportTemplate = template;
                this.data = {
                    vismaalias: this.getExportFlow("vismaalias"),
                    vismauserid: this.getExportFlow("vismauserid"),
                    vismaemailtype: this.getExportFlow("vismaemailtype"),
                    vismaemail: this.getExportFlow("vismaemail"),
                    vismainitials: this.getExportFlow("vismainitials"),
                };

                this.isUsername = !!this.data['vismaalias']?.expression;
                this.isEmail = !!this.data['vismaemailtype']?.expression || !!this.data['vismaemail']?.expression;
                this.isInitials = !!this.data['vismainitials']?.expression;

                this.isDefined = this.isUsername || this.isEmail || this.isInitials;

                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    private getExportFlow(targetattribute: string): IExportFlow | undefined {
        return this.dataExportTemplate.exportflow.find((item: IExportFlow) => item.targetattribute == targetattribute);
    }

}
